import styled from 'styled-components'
import { ellipsis } from 'polished'

import { baseSelectStyles } from 'components/Select'

import ChevronsUpDownIcon from 'icons/chevrons-up-down-24.svg'

export const ButtonTrigger = styled.button`
  ${baseSelectStyles}

  position: relative;
  text-align: left;

  min-height: 40px;
  padding-right: 44px;
  line-height: 1;

  cursor: pointer;

  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  box-shadow: 0px 0px 0px 2px transparent;

  transition: box-shadow 125ms ease-in-out;

  /* Prevent a large name from increasing the height */
  ${ellipsis()}

  &[aria-valuetext] {
    color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  }

  &[aria-expanded='true'],
  :focus {
    box-shadow: 0px 0px 0px 2px ${({ theme }) => theme.colors.primaryTint[50]};
  }

  ::after {
    content: '';
    margin: auto;

    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${ChevronsUpDownIcon});
    opacity: 0.55;

    width: 24px;
    height: 24px;

    position: absolute;
    top: 0;
    right: 8px;
    bottom: 0;
  }

  :disabled {
    cursor: default;
  }
`
